export default "__VITE_ASSET__CurQJlx9__";